<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.teachers") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.mode") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_mode')"
            name="subcategory_type"
            v-model="mode"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="categoryArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.exprtise") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_exprtise')"
            name="subcategory_type"
            v-model="interest"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="interestArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="code"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            placeholder="City"
            icon-no-border
            label="City"
            v-model="city"
            id="text-box-val-city"
            @keyup.delete="getAllTeacher()"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            placeholder="State"
            icon-no-border
            label="State"
            v-model="state"
            id="text-box-val-state"
            @keyup.delete="getAllTeacher()"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2" @click="getAllTeacher()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="closeForm()"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <div class="user-table">
        <vs-table :max-items="perPage" stripe :data="users">
          <template slot="thead">
            <vs-th>{{ $t("labels.id") }}</vs-th>
            <vs-th>{{ $t("labels.name") }}</vs-th>
            <vs-th>{{ $t("labels.email") }}</vs-th>
            <vs-th>{{ $t("labels.mode") }}</vs-th>
            <vs-th>{{ $t("labels.experience_expertise") }}</vs-th>
            <vs-th>{{ $t("labels.experience") }}</vs-th>
            <vs-th>{{ $t("labels.city") }}</vs-th>
            <vs-th>{{ $t("labels.state") }}</vs-th>
            <vs-th>{{ $t("labels.referral_total") }}</vs-th>
            <vs-th>{{ $t("labels.referred_by") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].id">
                {{ data[indextr].sr_no }}
              </vs-td>

              <vs-td :data="data[indextr].first_name">
                {{ data[indextr].first_name | upper }}
              </vs-td>

              <vs-td :data="data[indextr].email">
                {{ data[indextr].email }}
              </vs-td>

              <vs-td :data="data[indextr].mode">
                <p v-if="data[indextr].mode == 'OF'">
                  {{ $t("labels.offline") }}
                </p>
                <p v-if="data[indextr].mode == 'ON'">
                  {{ $t("labels.online") }}
                </p>
                <p v-if="data[indextr].mode == 'B'">{{ $t("labels.both") }}</p>
              </vs-td>

              <vs-td :data="data[indextr].additional_interests">
                {{ data[indextr].additional_interests }}
              </vs-td>
              <vs-td :data="data[indextr].experience">
                {{ data[indextr].experience | experience }}
              </vs-td>
              <vs-td :data="data[indextr].location.city">
                {{ data[indextr].location.city | upper }}
              </vs-td>
              <vs-td :data="data[indextr].location.state">
                {{ data[indextr].location.state | upper }}
              </vs-td>
              <vs-td :data="data[indextr].total_refered">
                {{ data[indextr].total_refered }}
              </vs-td>
              <vs-td :data="data[indextr].referred_name">
                {{ data[indextr].referred_name | upper }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    mode: "",
    city: "",
    state: "",
    interest: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    interest_search: "",
    mode_search: "",
    categoryArray: [
      {
        id: "ON",
        value: "Online",
      },
      {
        id: "OF",
        value: "Offline",
      },
      {
        id: "B",
        value: "Both",
      },
    ],
    interestArray: null,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllTeacher();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllTeacher();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllTeacher();
      }
    },
  },
  methods: {
    getAllTeacher() {
      if (this.interest) {
        this.interest_search = this.interest.id;
      } else {
        this.interest_search = "";
      }
      if (this.mode) {
        this.mode_search = this.mode.id;
      } else {
        this.mode_search = "";
      }
      let input = {
        mode: this.mode_search,
        interest: this.interest_search,
        city: this.city,
        state: this.state,
        page: this.currentPage,
        perPage: this.perPage,
      };
      console.log(input);
      axios
        .post("admin/getTeachers", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.user;
          console.log(this.users);
          if (data.count < this.perPage) {
            this.currentPage = 1;
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    getAllInterests() {
      axios
        .post("user/getAllInterest")
        .then((response) => {
          let data = response.data.data;
          console.log(data);
          this.interestArray = data;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.mode = ""),
        (this.interest = ""),
        (this.city = ""),
        this.getAllTeacher();
    },
    closeForm() {
      this.data_hide = !this.data_hide;
    },
    ClassDetails(id) {
      this.$router.push({ name: "ClassById", params: { id: id } });
    },
    clearInput() {
      let city = document.getElementById("text-box-val-city").value;
      if (city == "") {
        this.getAllTeacher();
      }
      let state = document.getElementById("text-box-val-state").value;
      if (state == "") {
        this.getAllTeacher();
      }
    },
  },
  mounted() {
    this.getAllTeacher();
    this.getAllInterests();
  },
};
</script>

<style lang="scss" scoped>
</style>